<template>
    <div id="index">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                    <el-form-item :label="$t('KeyWord')">
                        <el-input @keyup.enter.native='getRoles' class="queryform" v-model="formselect.queryString">
                        </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="getRoles">{{ $t('Query') }}</el-button>
                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                    </el-form-item>
                </el-form>
                <template>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addNew"
                               v-if="judge('Role_Create')"
                               style="margin-bottom:10px;">{{$t('Add')}}
                    </el-button>
                    <el-table :data="tableData1"
                              border
                              v-loading="loading"
                              style="width: 100%">

                        <el-table-column prop="name"
                                         :label="$t('RoleCode')"
                                         min-width="15%">
                        </el-table-column>
                        <el-table-column prop="displayName"
                                         :label="$t('RoleName')"
                                         min-width="20%">
                        </el-table-column>
<!--                        <el-table-column prop="displayName"-->
<!--                                         label="显示名"-->
<!--                                         min-width="25%">-->
<!--                        </el-table-column>-->
                        <el-table-column :label="$t('Action')"
                                         min-width="30%">
                            <template slot-scope="scope">
                                <el-button size="mini"
                                           v-if="judge('Role_Update')"
                                           type="primary"
                                           @click="openEdit(scope.row)">{{ $t('Edit') }}
                                </el-button>
                                <el-button size="mini"
                                           type="success"
                                           v-if="judge('Role_PermissionSet')"
                                           @click="quanx(scope.row)">{{ $t('OperatingAuthorization') }}
                                </el-button>
                                <template>
                                    <el-popconfirm placement="top"
                                                   v-if="judge('Role_Delete')"
                                                   :confirmButtonText="$t('Delete')"
                                                   :cancelButtonText="$t('Cancel')"
                                                   icon="el-icon-info"
                                                   iconColor="red"
                                                   :title="$t('DeleteConfirm')"
                                                   @onConfirm="deleteRoleInfo(scope.row)">
                                        <el-button size="mini" type="danger" slot="reference"
                                                   style=" margin-left: 10px;">{{ $t('Delete') }}
                                        </el-button>
                                    </el-popconfirm>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="pagination.totalPage"
                            :current-page.sync="pagination.current"
                            :page-size="pagination.pageSize"
                            @current-change="pageChange()"
                    ></el-pagination>
                </template>

            </el-main>
        </el-scrollbar>

        <el-dialog title="创建角色" :visible.sync="dialogAddRole" width="60%" top="10vh" @close="cancelAdd">
            <el-form ref="roleform" :model="roleform" label-width="150px">
<!--                <el-form-item label="角色编码">-->
<!--                    <el-input :disabled="true" placeholder="创建完成后自动生成" style="width: 300px;"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item :label="$t('RoleCode')">
                    <el-input v-model="roleform.name" style="max-width: 300px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('DisplayName')">
                    <el-input v-model="roleform.displayName" style="max-width: 300px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('SN')">
                    <el-input v-model="roleform.orderNum" style="max-width: 100px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('DataPermissionsType')" prop='dataPermissionType'>
                    <el-select v-model="roleform.dataPermissionType" :placeholder="$t('el.select.placeholder')" style=" max-width: 300px;">
                        <!--                        <el-option value='City' label="城市">城市</el-option>-->
                        <el-option value='All' :label="$t('All')">{{ $t('All') }}</el-option>
                        <el-option value='Factory' :label="$t('Campus')">{{ $t('Campus') }}</el-option>
                        <!--                        <el-option value='Building' label="楼宇">楼宇</el-option>-->
                        <el-option value='Laboratory' :label="$t('Lab')">{{ $t('Lab') }}</el-option>
                        <el-option value='Device' label="设备">设备</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="success" @click="addRoleInfo('roleform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="closeAddialog">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="编辑角色" :visible.sync="dialogEditRole" width="60%" top="10vh" @close="cancelEdit">
            <el-form ref="roleform" :model="roleform" label-width="150px">
<!--                <el-form-item label="角色编码">-->
<!--                    <el-input v-model="roleform.id" :disabled="true" style="width: 300px;"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item :label="$t('RoleCode')">
                    <el-input :disabled="true" v-model="roleform.name" style="max-width: 300px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('DisplayName')">
                    <el-input v-model="roleform.displayName" style="max-width: 300px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('SN')">
                    <el-input v-model="roleform.orderNum" style="max-width: 100px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('DataPermissionsType')" prop='dataPermissionType'>
                    <el-select v-model="roleform.dataPermissionType" :placeholder="$t('el.select.placeholder')" style=" max-width: 300px;">
                        <!--                        <el-option value='City' label="城市">城市</el-option>-->
                        <el-option value='All' :label="$t('All')">{{ $t('All') }}</el-option>
                        <el-option value='Factory' :label="$t('Campus')">{{ $t('Campus') }}</el-option>
                        <!--                        <el-option value='Building' label="楼宇">楼宇</el-option>-->
                        <el-option value='Laboratory' :label="$t('Lab')">{{ $t('Lab') }}</el-option>
                        <el-option value='Device' label="设备">设备</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="success" @click="editRoleInfo('roleform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="closeEditDialog">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="$t('OperatingAuthorization')" :visible.sync="dialogEditPermission" width="60%" top="10vh">
            <el-form ref="formPer" :model="formPer" label-position="left" label-width="150px" id="formPer">
                <el-form-item :label="$t('LevelMenu1')">
                    <el-form-item :label="$t('LevelMenu2')">
                        <el-form-item :label="$t('LevelMenu3')">
                            <span>{{$t('Purview')}}</span>

                        </el-form-item>
                    </el-form-item>
                </el-form-item>
                <div v-for="(item,index) in MenuData" :key="index">
                    <el-form-item :label="$t(item.label)">
                        <div v-if="item.children.length>0">
                            <div v-for="childitem in item.children" :key="childitem.id">

                                <el-form-item :label="$t(childitem.label)">

                                    <div v-if="childitem.children.length>0">

                                            <div v-for="childThree in childitem.children" :key="childThree.id">

                                                <el-form-item :label="$t(childThree.label)">
                                                    <el-checkbox-group v-model="operationsChoosed">
                                                        <el-checkbox v-for="opt in childThree.operations"
                                                                    :key="opt.code" :label="opt.code">
                                                {{opt.label}}
                                                        </el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                            </div>

                                    </div>
                                    <div v-else>
                                          <el-form-item label="-">
                                        <el-checkbox-group v-model="operationsChoosed">
                                            <el-checkbox v-for="opt in childitem.operations"
                                                        v-if="opt.IsGranted!=0"
                                                        :key="opt.code" :label="opt.code">
                                                {{opt.label}}
                                            </el-checkbox>
                                        </el-checkbox-group>
                                         </el-form-item>
                                    </div>

                                </el-form-item>
                            </div>
                        </div>
                        <div v-else>
                            <el-form-item label="-">
<!--                                <el-checkbox-group v-model="item.code">-->
<!--                                    <el-checkbox label="查看" name="code"></el-checkbox>-->
<!--                                </el-checkbox-group>-->
                                <div v-for="childitem in item.operations" :key="childitem.id">
                                    <el-form-item  label="-">
                                            <el-checkbox-group v-model="operationsChoosed">
                                                <el-checkbox :key="childitem.code" :label="childitem.code">
                                                    {{childitem.label}}
                                                </el-checkbox>
                                            </el-checkbox-group>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form-item>

                </div>

                <el-form-item class="noborder">
                    <el-button type="success" @click="onSubmit">{{ $t('DetermineAuthorization') }}</el-button>
                    <el-button @click="dialogEditPermission = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getRoles, RolePermissionSet,getAllpermissionMenu, addRoles, updateRoles, deleteRole, getAllRoles, GetAllMenus
    } from "../../api/api";
    import {mapState} from 'vuex';
    import {judgePermission} from '../../utils/util'

    export default {
        name: "Index",

        mounted() {
            this.getRoles();
            this.getDataList();
        },

        data() {
            return {
                dialogAddRole: false,
                loading: false,
                dialogEditRole: false,
                dialogEditPermission: false,
                tableData1: [],
                MenuData: [],
                operationsChoosed: [],
                formselect: {
                    queryString: ''
                },
                roleform: {
                    id: '',
                    name: '',
                    orderNum: '100',
                    displayName: '',
                    permissions: [],
                    dataPermissionType: ''
                },
                props: {multiple: true},
                optionsinfo: [
                    {
                        value: 1,
                        label: '全部',
                    },
                    {
                        value: 2,
                        label: '上海',
                        children: [{
                            value: 21,
                            label: '浦东园区',
                            children: [
                                {
                                    value: 211,
                                    label: this.$t('Building') + '001',
                                    children: [
                                        {
                                            value: 2111,
                                            label: this.$t('Lab') + '001'
                                        },
                                        {value: 2112, label: this.$t('Lab') + '002'},
                                        {value: 2113, label: this.$t('Lab') + '003'}
                                    ]
                                },
                                {
                                    value: 212,
                                    label: this.$t('Building') + '002',
                                    children: [
                                        {
                                            value: 2121,
                                            label: this.$t('Lab') + '001'
                                        },
                                        {value: 2122, label: this.$t('Lab') + '002'},
                                        {value: 2123, label: this.$t('Lab') + '003'}
                                    ]
                                },
                                {
                                    value: 213,
                                    label: this.$t('Building') + '003',
                                    children: [
                                        {
                                            value: 2131,
                                            label: this.$t('Lab') + '001'
                                        },
                                        {value: 2132, label: this.$t('Lab') + '002'},
                                        {value: 2133, label: this.$t('Lab') + '003'}
                                    ]
                                }
                            ]
                        },]
                    }],
                formPer: {},
                checkboxData: [],
                activeId: "",
                //分页
                pagination: {
                    current: 1,
                    pageSize: 10,
                    totalPage: 0
                },
            }
        },

        methods: {
            judge(e){
                return judgePermission(e)
            },
            async getRoles() {
                this.loading=true
                let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;   //开始条
                let data = await getAllRoles(this.formselect.queryString, skipcount, this.pagination.pageSize);
                this.pagination.totalPage = data.result.totalCount;
                this.tableData1 = data.result.items;
                this.loading=false
            },
            async addRoleInfo(formName) {
                try {
               
                    // this.roleform.displayName = this.roleform.name;
                    this.roleform.sort = this.roleform.orderNum;
                    delete this.roleform.id
                    const data = await addRoles(this.roleform);
                    this.dialogAddRole = false;
                    this.roleform = {
                        id: '',
                        name: '',
                        orderNum: '',
                        displayName: '',
                        permissions: [],
                        dataPermissionType: ''
                    };
                    if (data.success === true) {
                        this.$message({
                            message: this.$t('AddedSuccessfully'),
                            type: "success"
                        });
                        this.getRoles();
                    }
                } catch (e) {
           
                    this.dialogAddRole = false;
                    this.$message.error(e.error.message);
                }
                this.$refs[formName].validate(async valid => {
                    if (valid) {

                    }
                });
            },

            cancelAdd() {
                this.roleform = {
                    id: '',
                    name: '',
                    orderNum: '',
                    displayName: '',
                    permissions: [],
                    dataPermissionType: ''
                }
            },
            reset(){
                this.formselect.queryString = ''
                this.getRoles()
            },
            cancelEdit() {
                this.roleform = {
                    id: '',
                    name: '',
                    orderNum: '',
                    displayName: '',
                    permissions: [],
                    dataPermissionType: ''
                }
            },


            async editRoleInfo(formName) {
                try {
                 
                    // this.roleform.displayName = this.roleform.name;
                    this.roleform.sort = this.roleform.orderNum;
                    const data = await updateRoles(this.roleform);
                    this.dialogEditRole = false;
                    this.roleform = {
                        id: '',
                        name: '',
                        orderNum: '',
                        displayName: '',
                        permissions: [],
                        dataPermissionType: ''
                    }
                    if (data.success === true) {
                        this.$message({
                            message: this.$t('EditSuccessful'),
                            type: "success"
                        });
                        this.getRoles();
                    }
                } catch (e) {
             
                    this.dialogAddRole = false;
                    this.$message.error(e.error.message);
                }
                this.$refs[formName].validate(async valid => {
                    if (valid) {

                    }
                });
            },
            addNew(){
                this.dialogAddRole = true
                this.roleform = {
                    id: '',
                    name: '',
                    orderNum: '100',
                    displayName: '',
                    permissions: [],
                    dataPermissionType: ''
                }
            },
            quanx(row) {
                var that = this
                this.roleform.permissions = JSON.parse(JSON.stringify(row)).permissions;
                this.activeId = JSON.parse(JSON.stringify(row)).id
                this.dialogEditPermission = true
                this.operationsChoosed = that.roleform.permissions
               
            },
            async openEdit(row) {
                var that = this
                this.roleform = JSON.parse(JSON.stringify(row));
                // this.roleform.orderNum = this.roleform.orderNum
                this.dialogEditRole = true;
            },
            async deleteRoleInfo(row) {
             
                const data = await deleteRole(parseInt(row.id));
                if (data.success === true) {
                    this.$message({
                        message: this.$t('deleteSuccessful'),
                        type: "success"
                    });
                    this.getRoles();
                }
            },

            async pageChange() {
                this.getRoles();
            },
            async closeAddialog() {
                this.dialogAddRole = false;
                this.roleform = {
                    id: '',
                    name: '',
                    orderNum: '',
                    displayName: '',
                    permissions: [],
                    dataPermissionType: ''
                }
            },
            async closeEditDialog() {
                this.dialogEditRole = false;
                this.roleform = {
                    id: '',
                    name: '',
                    orderNum: '',
                    displayName: '',
                    permissions: [],
                    dataPermissionType: ''
                }
            },
            //操作授权
            getDataList() {
                let that = this
                if(this.judge('Role_PermissionSet')){
                    //getAllpermissionMenu
                    getAllpermissionMenu().then(res => {
                       
                        let data = res.result
                        data = JSON.stringify(data).replace(/name/g, 'label')
                        that.MenuData = JSON.parse(data)
               
                    })
                }
            },

            handleChange() {
                this.checkEquipArr = []
                let arr = this.checkedEquipments
                for (let i = 0; i < arr.length; i++) {
                    let equipment = arr[i]
                    if (equipment.length > 0) {
                        let obj = {
                            id: this.equipments[i].id,
                            equips: []
                        }
                        for (let j = 0; j < equipment.length; j++) {
                            obj.equips.push(equipment[j])
                        }
                        this.checkEquipArr.push(obj)
                    }
                }
          
            },
            openNotice() {
                this.$notify({
                    title: this.$t('warn'),
                    message: this.$t('warningMessage'),
                    type: 'warning'
                });
            },

            handleAccredit(index, row) {
              
            },
            handleDelete(index, row) {
              
            },
            onSubmit() {
              
                var that = this, data = {
                    id: this.activeId,
                    permissions: this.operationsChoosed
                }
                this.dialogEditPermission = false;
                RolePermissionSet(data).then(res => {
               
                    if (res.success) {
                        that.getRoles()
                        that.$message({
                            message: this.$t('SuccessfullySaved'),
                            type: "success"
                        });
                    } else {
                        that.$message({
                            message: this.$t('SaveFailed'),
                            type: "error"
                        });
                    }
                }, err => {
                    that.$meassage.error(err.error.message)
                })
            }
        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>
    #formPer .el-form-item__content {
        line-height: 35px;
        border-left: 1px solid #EBEEF5;
        padding-left: 10px;
    }

    #formPer > .el-form-item {
        margin-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
    }

    #formPer .noborder .el-form-item__content {
        border: 0;
    }

    #formPer .noborder {
        border: 0;
        margin-top: 20px;
    }
</style>
